import { Form, Button, Input, Modal, Table, notification, Tag, Space, Select, InputNumber } from 'antd'
import { useContext, useEffect, useState } from 'react'
import { PlusCircleTwoTone, MinusCircleOutlined, PlusOutlined, CloudDownloadOutlined, PauseCircleOutlined, PlayCircleOutlined, DeleteFilled, ExclamationCircleFilled } from '@ant-design/icons'
import { EditFilled } from '@ant-design/icons'
import './styles.css'

import { Context } from '../../context'
import { Fetch, Post, Put, Patch, Delete } from '../../fetch'
import { convertIdToKey, handleExportClick } from '../../utils'
import MultiCurrencyInput from '../MultiCurrencyInput/index'
import Loading from '../Loading'
import moment from "moment";
import CompoundedSpace from 'antd/lib/space'
import RentalsPricingInput from "../RentalsPricingInput";

const { Column } = Table
const { Option } = Select
const { confirm } = Modal;

const ManagePlans = () => {
  const { token, apiUrl } = useContext(Context)

  const [plans, setPlans] = useState([])
  const [applePlans, setApplePlans] = useState([])
  const [androidPlans, setAndroidPlans] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [planId, setPlanId] = useState()
  const [editPlan, setEditPlan] = useState({ price: {} })
  const [pageType, setPageType] = useState('web')
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [movies, setMovies] = useState([]); // for bundle content
  const [series, setSeries] = useState([]); // for bundle content
  const [moviesList, setMoviesList] = useState([]);
  const [seriesList, setSeriesList] = useState([]);
  const [bundlePlans, setBundlePlans] = useState([]);
  const [contentEdited, setContentEdited] = useState(false);
  const [contentDeleted, setContentDelected] = useState(false);
  const [monetizationStreamingForm] = Form.useForm();
  const [form] = Form.useForm()

  useEffect(() => {
    if (pageType === "web") {
      setData(plans)
    }
    if (pageType === "apple") {
      setData(applePlans)
    }
    if (pageType === "android") {
      setData(androidPlans)
    }
    if (pageType === "bundleTicket") {
      setData(bundlePlans)
    }
  }, [])

  // for web plans
  useEffect(() => {

    if (pageType === 'web') {
      Fetch(`${apiUrl}/plans/cms?type=${pageType}`, token, (result) => {
        const plans = convertIdToKey(result.plans)
        plans.forEach(plan => {
          const type_of_isprivate = typeof (plan.isPrivate);

          if ((type_of_isprivate === "undefined") || (plan.isPrivate === "False")) {
            plan.isPrivate = "public";
          } else {
            plan.isPrivate = "private";
          }
        })
        setPlans(plans)
        setData(plans)
      }
      )
    }
    if (!planId) {
      return
    }

    Fetch(`${apiUrl}/plans/${planId}`, token, (result) => {
      const { ...others } = result;
      console.log("hello");
      form.setFieldsValue(others);
    })
  }, [apiUrl, token, pageType, confirmLoading, contentEdited, contentDeleted])

  // for apple plans
  useEffect(() => {
    if (pageType === 'apple') {
      Fetch(`${apiUrl}/plans/cms?type=${pageType}`, token, (result) => {
        const apple_plans = convertIdToKey(result.plans)

        apple_plans.forEach(plan => {
          if (!plan.name) {
            plan.name = plan.planId
          }
        })
        setData(apple_plans)
      })
    }
  }, [apiUrl, token, pageType, confirmLoading, contentEdited, contentDeleted])

  // for andriod plans
  useEffect(() => {
    if (pageType === 'android') {
      Fetch(`${apiUrl}/plans/cms?type=${pageType}`, token, (result) => {
        const android_plans = convertIdToKey(result.plans)

        android_plans.forEach(plan => {
          if (!plan.name) {
            plan.name = plan.planId
          }
        })
        setAndroidPlans(android_plans);
        setData(android_plans)
      })
    }
  }, [apiUrl, token, pageType, confirmLoading, contentEdited, contentDeleted])

  // for bundle plans
  useEffect(() => {

    if (pageType === "bundleTicket") {
      Fetch(`${apiUrl}/plans/cms?type=bundle`, token, (result) => {
        const bundles_plans = convertIdToKey(result.plans)
        bundles_plans.forEach(plan => {
          if (!plan.name) {
            const selectedMovies = plan?.movies?.length >= 1 ? plan.movies : "";
            const selectedSeries = plan?.series?.length >= 1 ? plan.series : "";
            const combinedSelectedContents = [...selectedMovies, ...selectedSeries];
            const contents = [...movies, ...series];

            const labels = contents
              .filter(content => combinedSelectedContents.includes(content.value))
              .map(content => content.label);

            plan.name = labels?.join(', ');
          }
        })

        setBundlePlans(bundles_plans);
        setData(bundles_plans)
      })
    }
  }, [apiUrl, token, pageType, confirmLoading, contentEdited, contentDeleted])

  // create plans api call
  const handleSubmit = async () => {

    let valid = true
    try {
      valid = await form.validateFields()
    }
    catch {
      valid = false
    }

    if (!valid) {
      notification.error({
        message: "Error",
        description: "Required Fields are Missing"
      })
      return
    }
    setLoading(true)

    if (pageType === 'web') {
      try {
        setConfirmLoading(true)
        let price = form.getFieldValue('price')
        let price_t = {} // to store the sales price keys and values
        let mrp_t = {} // to store the mrp keys and values
        Object.entries(price).map(([k, v]) =>
          (k.includes("_MRP") ? (mrp_t[k] = v) : (price_t[k] = v)))
        let values = form.getFieldsValue()
        values = { ...values, price: price_t, mrp: mrp_t }
        Post(
          `${apiUrl}/plans`,
          token,
          { ...values },
          (result) => {
            if (result.success) {
              setContentEdited(true);
              notification.success({
                message: 'Success',
                description: 'Plan created'
              })
            }
            form.resetFields()
            monetizationStreamingForm.resetFields()
            setModalVisible(false)
            setLoading(false)
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Add Plan Error',
              description: 'Check console for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Add Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      } finally {
        setConfirmLoading(false)
      }
    }

    if (pageType === 'apple') {
      try {
        setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log(values.planId)
        Post(
          `${apiUrl}/plans/applePlan`,
          token,
          { ...values, planType: "applePlan", },
          (result) => {
            if (result.success) {
              setContentEdited(true);
              notification.success({
                message: 'Success',
                description: 'Plan created'
              })
            }
            form.resetFields()
            monetizationStreamingForm.resetFields()
            setModalVisible(false)
            setLoading(false)
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Add Plan Error',
              description: 'Check console for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Add Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      } finally {
        setConfirmLoading(false)
      }
    }

    if (pageType === 'android') {
      try {
        setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log(values.planId)
        Post(
          `${apiUrl}/plans/androidPlan`,
          token,
          { ...values, planType: "androidPlan", },
          (result) => {
            if (result.success) {
              setContentEdited(true);
              notification.success({
                message: 'Success',
                description: 'Plan created'
              })
            }
            form.resetFields()
            monetizationStreamingForm.resetFields()
            setModalVisible(false)
            setLoading(false)
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Add Plan Error',
              description: 'Check console for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Add Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      } finally {
        setConfirmLoading(false)
      }
    }

    if (pageType === "bundleTicket") {
      try {
        setConfirmLoading(true)
        let values = form.getFieldsValue()
        const selectedMovies = valid?.movies
        const selectedIdsMovies = selectedMovies?.length >= 1 ? moviesList?.[0]?.movies?.filter(movie => selectedMovies.includes(movie.title)).map(movie => movie._id) : [];

        const selectedseries = valid?.series
        const selectedIdsSeries = selectedseries?.length >= 1 ? seriesList?.[0]?.series?.filter(serie => selectedseries.includes(serie.title)).map(serie => serie._id) : [];
        const monetizationStreaming = await monetizationStreamingForm.validateFields();
        values.movies = selectedIdsMovies
        values.series = selectedIdsSeries
        values.expiry = 30

        Post(
          `${apiUrl}/bundle`,
          token,
          { ...values,...monetizationStreaming, planType: "bundlePlan", },
          (result) => {
            if (result.success) {
              setContentEdited(true);
              notification.success({
                message: 'Success',
                description: 'Plan created'
              })
            }
            form.resetFields()
            monetizationStreamingForm.resetFields()
            setModalVisible(false)
            setLoading(false)
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Add Plan Error',
              description: 'Check console for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Add Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      } finally {
        setConfirmLoading(false)
      }
    }
  }

  // for edit plans open showing previously values
  const getPlanDetails = async (id) => {

    if (pageType === 'web') {
      Fetch(`${apiUrl}/plans/cms/${id}?type=${pageType}`, token, (result) => {
        const { ...others } = result;
        setEditPlan({ ...result, price: { ...result.price, ...result.mrp } })
        others.price = { ...result.price, ...result.mrp }
        console.log("others", others)
        form.setFieldsValue(others);
        setPlanId(id);
      })
    }

    if (pageType === 'apple') {
      Fetch(`${apiUrl}/plans/cms/${id}?type=${pageType}`, token, (result) => {
        setEditPlan({ planId: result.planId })
        console.log("result: ", result)
        form.setFieldValue("planId", result.planId);
        form.setFieldValue("price", result.price);
        form.setFieldValue("duration", result.duration);
        setPlanId(id);
      })
    }

    if (pageType === 'android') {
      Fetch(`${apiUrl}/plans/cms/${id}?type=${pageType}`, token, (result) => {
        setEditPlan({ planId: result.planId })
        console.log("result: ", result)
        form.setFieldValue("planId", result.planId);
        form.setFieldValue("price", result.price);
        form.setFieldValue("duration", result.duration);
        setPlanId(id);
      })
    }

    if (pageType === 'bundleTicket') {
      Fetch(`${apiUrl}/plans/cms/${id}?type=bundle`, token, (result) => {
        setEditPlan({ planId: result.planId })
        form.setFieldValue("planName", result.planName);
        form.setFieldValue("planId", result.planId);
        form.setFieldValue("price", result.price);
        form.setFieldValue("expiry", result.expiry);

        monetizationStreamingForm.setFieldValue("price", result.price)
      
        const movieLabels = result?.movies?.length >= 1 ? result.movies.map(value => {
          const movie = movies.find(movie => movie.value === value);
          return movie ? movie?.label : null;
        }).filter(label => label !== null) : null;

        const seriesLabels = result?.series?.length >= 1 ? result.series.map(value => {
          const serie = series.find(movie => movie.value === value);
          return serie ? serie?.label : null;
        }).filter(label => label !== null) : null;

        if (movieLabels?.length >= 1) {
          form.setFieldValue("movies", movieLabels)
        }

        if (seriesLabels?.length >= 1) {
          form.setFieldValue("series", seriesLabels)
        }

        setPlanId(id);
      })
    }

  }

  // edit plan api call
  const handleEditSubmit = async () => {
    let valid = true
    try {
      valid = await form.validateFields()
    }
    catch {
      valid = false
    }

    if (!valid) {
      notification.error({
        message: "Error",
        description: "Required Fields are Missing"
      })
      return
    }

    setLoading(true)
    if (pageType === 'web') {
      try {
        await setConfirmLoading(true)
        let price = form.getFieldValue('price')
        let price_t = {} // to store the sales price keys and values
        let mrp_t = {} // to store the mrp keys and values
        Object.entries(price).map(([k, v]) =>
          (k.includes("_MRP") ? (mrp_t[k] = v) : (price_t[k] = v)))
        let values = form.getFieldsValue()
        values = { ...values, price: price_t, mrp: mrp_t }
        // console.log(values)
        Put(
          `${apiUrl}/plans/${planId}`,
          token,
          { ...values },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Edited successfully'
              })
              form.resetFields()
              monetizationStreamingForm.resetFields()
              setEditModalVisible(false)
              setPlanId(null)
              setLoading(false)
            }
            setContentEdited(true);
          },
          () => {
            notification.error({
              message: 'Error updating plan',
              description: 'Please check logs for more details'
            })
          }
        )

      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Edit Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      }
      finally {
        await setConfirmLoading(false)
      }
    }
    if (pageType === 'apple') {
      console.log("pageEdit: ", pageType)
      try {
        await setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log("Edit Values: ", values)
        Put(
          `${apiUrl}/plans/applePlan/${planId}`,
          token,
          { ...values, planType: "applePlan" },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Edited successfully'
              })
              form.resetFields()
              monetizationStreamingForm.resetFields()
              setEditModalVisible(false)
              setPlanId(null)
              setLoading(false)
              setContentEdited(true);
            }
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Error updating plan',
              description: 'Please check logs for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Edit Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      }
      finally {
        await setConfirmLoading(false)
      }
    }
    if (pageType === 'android') {

      try {
        await setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log("Edit Values: ", values)
        Put(
          `${apiUrl}/plans/androidPlan/${planId}`,
          token,
          { ...values, planType: "androidPlan" },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Edited successfully'
              })
              form.resetFields()
              monetizationStreamingForm.resetFields()
              setEditModalVisible(false)
              setPlanId(null)
              setLoading(false)
              setContentEdited(true);
            }
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Error updating plan',
              description: 'Please check logs for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Edit Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      }
      finally {
        await setConfirmLoading(false)
      }
    }
    if (pageType === "bundleTicket") {

      try {
        await setConfirmLoading(true)
        let values = form.getFieldsValue()
        const selectedMovies = valid?.movies
        const selectedIdsMovies = selectedMovies?.length >= 1 ? moviesList?.[0]?.movies?.filter(movie => selectedMovies.includes(movie.title)).map(movie => movie._id) : [];

        const selectedseries = valid?.series
        const selectedIdsSeries = selectedseries?.length >= 1 ? seriesList?.[0]?.series?.filter(serie => selectedseries.includes(serie.title)).map(serie => serie._id) : [];
        const monetizationStreaming = await monetizationStreamingForm.validateFields();
        values.movies = selectedIdsMovies
        values.series = selectedIdsSeries
        values.expiry = 30

        Put(
          `${apiUrl}/bundle/${planId}`,
          token,
          { ...values,...monetizationStreaming, planType: "bundle" },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Edited successfully'
              })
              form.resetFields()
              monetizationStreamingForm.resetFields()
              setEditModalVisible(false)
              setPlanId(null)
              setLoading(false)
              setContentEdited(true);
            }
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Error updating plan',
              description: 'Please check logs for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Edit Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      }
      finally {
        await setConfirmLoading(false)
      }
    }
  }

  // for toggle action suspended
  const toggleState = async (planId) => {
    console.log(planId)
    console.log("Page for Toggling Status: ", plans)
    if (pageType === 'web') {
      const toggledFlag = !plans.filter(p => p.key === planId)[0].suspended
      try {
        await setConfirmLoading(true)
        Patch(
          `${apiUrl}/plans/${planId}`,
          token,
          { suspended: toggledFlag },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan state toggled successfully'
              })
            }
          },
          () => {
            notification.error({
              message: 'Plan State Toggle Error',
              description: 'Check console for more details'
            })
          }
        )
      } finally {
        await setConfirmLoading(false)
      }
    }
    if (pageType === "apple") {
      const toggledFlag = !applePlans.filter(p => p.key === planId)[0].suspended
      try {
        await setConfirmLoading(true)
        Patch(
          `${apiUrl}/plans/applePlan/${planId}`,
          token,
          { suspended: toggledFlag },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan state toggled successfully'
              })
            }
          },
          () => {
            notification.error({
              message: 'Plan State Toggle Error',
              description: 'Check console for more details'
            })
          }
        )
      } finally {
        await setConfirmLoading(false)
      }
    }

    if (pageType === "android") {
      const toggledFlag = !androidPlans.filter(p => p.key === planId)[0].suspended
      try {
        await setConfirmLoading(true)
        Patch(
          `${apiUrl}/plans/androidPlan/${planId}`,
          token,
          { suspended: toggledFlag },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan state toggled successfully'
              })
            }
          },
          () => {
            notification.error({
              message: 'Plan State Toggle Error',
              description: 'Check console for more details'
            })
          }
        )
      } finally {
        await setConfirmLoading(false)
      }
    }
  }

  // when plan type change show respective plan
  const handlePageChange = (page) => {

    if (page === "web") {
      setPageType("web")
      setData(plans)
    }
    if (page === "apple") {
      setPageType("apple")
      setData(applePlans)
    }
    if (page === "android") {
      setPageType("android")
      setData(androidPlans)
    }
    if (page === "bundleTicket") {
      setPageType("bundleTicket")
      setData(bundlePlans)
    }
  }

  // fetching movies and series for bundle content
  useEffect(() => {

    Fetch(`${apiUrl}/movies`, token, (result) => {
      const movies = convertIdToKey([result]);

      const options = movies?.[0]?.movies?.filter(movie => movie?.model === "ticket").map(movie => ({
        value: movie._id,
        label: movie.title,

      }));
      setMovies(options);
      setMoviesList(movies);
    });

    Fetch(`${apiUrl}/series`, token, (result) => {
      const series = convertIdToKey([result]);
      const options = series?.[0]?.series?.filter(movie => movie?.model === "ticket").map(series => ({
        value: series._id,
        label: series.title
      }));

      setSeries(options);
      setSeriesList(series);
    });

  }, [])

  // delete bundle plan
  const confirmDelete = (id) => {

    confirm({
      title: "Are you sure you want to delete this Bundle plan",
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        Delete(`${apiUrl}/bundle/${id}`, token, (result) => {
          console.log("delete budle", result)
          if (result.success) {
            notification.success({
              message: "Success",
              description: "Bundle plan delected succesfully",
            });
            setContentDelected(true);
          } else {
            notification.error({
              message: "Failure",
              description: "Failed to delete bundle plan",
            });
          }

        })
      }
    })
  };

  return (
    <>
      {
        loading ? <Loading /> : ''
      }
      <div className="manage-plans-wrapper">
        <Space direction='horizontal' size={"middle"}>
          <Select
            style={{ width: 200, marginBottom: 20, }}
            placeholder="Select Plan Type"
            showSearch
            onChange={handlePageChange}
            defaultValue='web'
          >
            <Option value="web">Web Plans</Option>
            <Option value="apple">Apple Plans</Option>
            <Option value="android">Google Play Plans</Option>
            <Option value="bundleTicket">Bundle Tickets</Option>
          </Select>
        </Space>
        <Table dataSource={data}>

          {pageType !== "bundleTicket" && <Column title="Name" dataIndex="name" key="name" align="center" />}

          {pageType === "bundleTicket" && <Column title="Name" dataIndex="planName" key="planName" align="center" />}

          {pageType === "bundleTicket" && <Column
            title={<div style={{ textAlign: 'center' }}>Contents</div>}
            dataIndex="name"
            key="name"
            align="left"
          />
          }

          {pageType === "web" && (<Column title="Price" dataIndex="price" key="price" align="center"
            render={(_, record) => record.price && Object.entries(record.price).map(([cc, price]) => (
              <Tag>{cc} : {price}</Tag>
            ))}
          />)}

          {pageType === "web" && (<Column
            title="Duration (days)"
            dataIndex="duration"
            key="duration"
            align="center"
          />)}

          {pageType === "bundleTicket" && (<Column
            title="Duration (days)"
            dataIndex="expiry"
            key="expiry"
            align="center"
          />)}

          <Column
            title="Status"
            dataIndex="suspended"
            key="suspended"
            align="center"
            render={v => v ? 'Suspended' : 'Active'}
          />

          <Column
            title="Actions"
            key="action"
            align="center"
            render={(text, record) => (
              <Space size="middle">
                <a
                  onClick={() => {
                    setPlanId(record.key);
                    getPlanDetails(record.key);
                    setEditModalVisible(true);
                    console.log(record.key, 'recordkey for edit or toggleStatus',);
                  }}
                >
                  {<EditFilled />}
                </a>

                {pageType !== "bundleTicket" ? (
                  <a onClick={() => toggleState(record.key)}>
                    {record.suspended ? <PlayCircleOutlined /> : <PauseCircleOutlined />}
                  </a>
                ) : (
                  <a onClick={() => confirmDelete(record.key)}>Delete</a>
                )}

              </Space>
            )}
          />
        </Table>
        <PlusCircleTwoTone
          twoToneColor="#FF0091"
          style={{ fontSize: '48px' }}
          className="add-plan-btn"
          onClick={() => { setModalVisible(true); console.log("pageType", pageType) }}
        />
        {/* <CloudDownloadOutlined
          className="export-btn"
          onClick={() => handleExportClick(apiUrl, token, 'plans')}
        /> */}

        {/* create modal */}
        <Modal
          title={pageType === "bundleTicket" ? "Add Bundle" : "Add Plan"}
          visible={modalVisible}
          onOk={handleSubmit}
          okText="Submit"
          onCancel={() => { setModalVisible(false); form.resetFields();monetizationStreamingForm.resetFields() }}
          confirmLoading={confirmLoading}
          maskClosable={false}
          destroyOnClose={true}
        >
          <Form form={form} layout="vertical" initialValues={{ gender: 'M' }}>
            {pageType === "web" && (<>
              <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item
                name="price"
                label={
                  <Space direction="horizontal">
                    <Tag style={{ width: 200, backgroundColor: 'white', border: 0, fontSize: 14, }} >
                      Currency
                    </Tag>
                    <Tag style={{ width: 100, backgroundColor: 'white', border: 0, fontSize: 14, }}>
                      MRP
                    </Tag>
                    <Tag style={{ width: 100, backgroundColor: 'white', border: 0, fontSize: 14, }}>
                      Sale Price
                    </Tag>
                  </Space>}
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: async (_, values) => {
                      for (let k in values) {
                        if (values[k] > values[k + "_MRP"]) {
                          return Promise.reject(new Error('Sale Price cannot be greater than MRP'));
                        }
                      }
                    },
                  },
                ]}
              >
                <MultiCurrencyInput form={form} fieldName={'price'} >Currency</MultiCurrencyInput>
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option>
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.List
                name="features"
                rules={[
                  {
                    validator: async (_, features) => {
                      if (!features || features.length < 2)
                        return Promise.reject(new Error('At least 2 features'));
                    },
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item
                        label={index === 0 ? 'Features' : ''}
                        required={false}
                        key={field.key}
                      >
                        <Form.Item
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message:
                                'Please input feature or delete this field.',
                            },
                          ]}
                          noStyle
                        >
                          <Input style={{ width: '95%' }} />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-btn"
                            onClick={() => remove(field.name)}
                          />
                        ) : null}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        icon={<PlusOutlined />}
                      >
                        Add feature
                      </Button>
                      <Form.ErrorList errors={errors} />
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </>
            )}
            {(pageType === "apple") && (<>
              <Form.Item name="planId" label="Plan ID" rules={[{ required: true, }]}>
                <Input placeholder='Enter the Plan ID' />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in USD' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option>
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}
            {(pageType === "android") && (<>
              <Form.Item name="planId" label="Plan ID" rules={[{ required: true, }]}>
                <Input placeholder='Enter the Plan ID' />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in INR' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  {/* <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option> */}
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}
            {(pageType === "bundleTicket") && (
              <>
                <Form.Item name="planName" label="Bundle Name" rules={[{ required: true }]}>
                  <Input placeholder='Enter the Bundle Name' />
                </Form.Item>
                {(pageType === "bundleTicket") &&
                  <Form form={monetizationStreamingForm} layout="vertical">
                    <Form.Item
                      name="price"
                      label="Bundle Price"
                      className="form-item-selector"
                      rules={[{ required: true }]}
                      initialValue={{
                        INR: 1,
                        USD: 1,
                        EUR: 1,
                        SGD: 1,
                        AED: 1,
                        NPR: 1,
                        MUR: 1,
                        BDT: 1,
                        GBP: 1,
                      }}
                    >
                      <RentalsPricingInput
                        form={monetizationStreamingForm}
                        fieldName={"price"}
                      ></RentalsPricingInput>
                    </Form.Item>
                  </Form>
                }

                <Form.Item
                  name="movies"
                  label="Movies"
                  rules={[{ required: false }]}
                >
                  <Select
                    placeholder="Choose Movies"
                    mode="multiple"
                  >
                    {movies?.map((genre) => (
                      <Option value={genre.label}>{genre.label}</Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="series"
                  label="Series"
                  rules={[{ required: false }]}
                >
                  <Select
                    placeholder="Choose Series"
                    mode="multiple"
                  >
                    {series?.map((serie) => (
                      <Option value={serie.label}>{serie.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="expiry" label="Bundle Validity (in days)" rules={[{ required: false }]}>
                  <InputNumber
                    min={1}
                    defaultValue={30}
                    disabled
                  />
                  <p style={{ color: "#00000073" }}>Number of days the purchase is valid for streaming</p>
                </Form.Item>
                <Form.Item label="Streaming Period (in days)" rules={[{ required: false }]}>
                  <InputNumber
                    defaultValue={3}
                    disabled
                  />
                </Form.Item>

              </>
            )}


          </Form>
        </Modal>

        {/* edit modal */}
        <Modal
          title={pageType === "bundleTicket" ? "Edit Bundle" : "Edit Plan"}
          visible={editModalVisible}
          onOk={handleEditSubmit}
          okText="Update"
          onCancel={() => { setEditModalVisible(false); form.resetFields() ;monetizationStreamingForm.resetFields() }}
          confirmLoading={confirmLoading}
          maskClosable={false}
        >
          <Form form={form} layout="vertical" initialValues={{ gender: 'M' }}>
            {pageType === "web" && (
              <>
                <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Form.Item
                  name="price"
                  label={
                    <Space direction="horizontal">
                      <Tag style={{ width: 200, backgroundColor: 'white', border: 0, fontSize: 14, }} >
                        Currency
                      </Tag>
                      <Tag style={{ width: 100, backgroundColor: 'white', border: 0, fontSize: 14, }}>
                        MRP
                      </Tag>
                      <Tag style={{ width: 100, backgroundColor: 'white', border: 0, fontSize: 14, }}>
                        Sale Price
                      </Tag>
                    </Space>}
                  rules={[
                    {
                      required: true,
                    },
                    {
                      validator: async (_, values) => {
                        for (let k in values) {
                          if (values[k] > values[k + "_MRP"]) {
                            return Promise.reject(new Error('Sale Price cannot be greater than MRP'));
                          }
                        }
                      },
                    },
                  ]}
                >
                  <MultiCurrencyInput value={{ ...editPlan.price }} form={form} fieldName={'price'} ></MultiCurrencyInput>
                </Form.Item>
                <Form.Item
                  name="duration"
                  label="Duration"
                  rules={[{ required: true }]}
                >
                  <Select disabled={true}>
                    <Select.Option key={7} value={7}>
                      {"Weekly"}
                    </Select.Option>
                    <Select.Option key={30} value={30}>
                      {"Monthly"}
                    </Select.Option>
                    <Select.Option key={90} value={90}>
                      {"Quarterly"}
                    </Select.Option>
                    <Select.Option key={365} value={365}>
                      {"Yearly"}
                    </Select.Option>
                  </Select>
                </Form.Item>
                <Form.List
                  name="features"
                  rules={[
                    {
                      validator: async (_, features) => {
                        if (!features || features.length < 2)
                          return Promise.reject(new Error('At least 2 features'));
                      },
                    },
                  ]}
                >
                  {(fields, { add, remove }, { errors }) => (
                    <>
                      {fields.map((field, index) => (
                        <Form.Item
                          label={index === 0 ? 'Features' : ''}
                          required={false}
                          key={field.key}
                        >
                          <Form.Item
                            {...field}
                            validateTrigger={['onChange', 'onBlur']}
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message:
                                  'Please input feature or delete this field.',
                              },
                            ]}
                            noStyle
                          >
                            <Input style={{ width: '95%' }} />
                          </Form.Item>
                          {fields.length > 1 ? (
                            <MinusCircleOutlined
                              className="dynamic-delete-btn"
                              onClick={() => remove(field.name)}
                            />
                          ) : null}
                        </Form.Item>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          icon={<PlusOutlined />}
                        >
                          Add feature
                        </Button>
                        <Form.ErrorList errors={errors} />
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </>
            )}
            {(pageType === "apple") && (<>
              <Form.Item name="planId" label="Pland ID" rules={[{ required: true, }]}>
                <Input placeholder="Enter Plan ID" />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in USD' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  {/* <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option> */}
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}
            {(pageType === "android") && (<>
              <Form.Item name="planId" label="Pland ID" rules={[{ required: true, }]}>
                <Input placeholder="Enter Plan ID" />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in INR' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  {/* <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option> */}
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}

            {(pageType === "bundleTicket") && (
              <>
                <Form.Item name="planName" label="Bundle Name" rules={[{ required: true }]}>
                  <Input placeholder='Enter the Bundle Name' />
                </Form.Item>

                {(pageType === "bundleTicket") &&
                  <Form form={monetizationStreamingForm} layout="vertical">
                    <Form.Item
                      name="price"
                      label="Bundle Price"
                      className="form-item-selector"
                      rules={[{ required: true }]}
                      initialValue={{
                        INR: 1,
                        USD: 1,
                        EUR: 1,
                        SGD: 1,
                        AED: 1,
                        NPR: 1,
                        MUR: 1,
                        BDT: 1,
                        GBP: 1,
                      }}
                    >
                      <RentalsPricingInput
                        form={monetizationStreamingForm}
                        fieldName={"price"}
                      ></RentalsPricingInput>
                    </Form.Item>
                  </Form>
                }

                <Form.Item
                  name="movies"
                  label="Movies"
                  rules={[{ required: false }]}
                >
                  <Select
                    placeholder="Choose Movies"
                    mode="multiple"
                  >
                    {movies?.map((genre) => (
                      <Option value={genre.label}>{genre.label}</Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="series"
                  label="Series"
                  rules={[{ required: false }]}
                >
                  <Select
                    placeholder="Choose Series"
                    mode="multiple"
                  >
                    {series?.map((serie) => (
                      <Option value={serie.label}>{serie.label}</Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item name="expiry" label="Bundle Validity (in days)" rules={[{ required: false }]}>
                  <InputNumber
                    min={1}
                    defaultValue={30}
                    disabled
                  />
                  <p style={{ color: "#00000073" }}>Number of days the purchase is valid for streaming</p>
                </Form.Item>
                <Form.Item label="Streaming Period (in days)" rules={[{ required: false }]}>
                  <InputNumber
                    defaultValue={3}
                    disabled
                  />
                </Form.Item>
              </>
            )}
          </Form>
        </Modal>
      </div>
    </>
  );
}

export default ManagePlans